var _defs, _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.52 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke:#ff0013;stroke-width:2px;}.cls-2{stroke:#ff0619;}.cls-3{font-size:12px;fill:#ff0013;font-family:MyriadPro-Regular, Myriad Pro;letter-spacing:0em;}.cls-4{letter-spacing:-0.02em;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.48,
    y: 1.04,
    width: 70.56,
    height: 19.92,
    rx: 9.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.12,7,8,15M8,7,16.12,15"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(23.08 15.19)"
  }, "Un-", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 18.14,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.23,
    y: 0
  }, "aid"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/unpaid.330b29f2614e9cdfd3e941f60b65ab2a.svg";
export { ForwardRef as ReactComponent };